import { gql } from '@apollo/client'

import { ComponentType } from '../../types'
import {
  ChooseFrequencyLaterSteps_OfferLockDataFragment,
  ChooseFrequencyLaterSteps_ViewerFragment,
} from './__generated__/choose-frequency-later-steps.graphql'
import { ChooseFrequencyLaterStepsContent } from './components'
import { ChooseFrequencyLaterContextProvider } from './context-provider'

interface ChooseFrequencyLaterStepsProps {
  offerLockData: ChooseFrequencyLaterSteps_OfferLockDataFragment
  viewer: ChooseFrequencyLaterSteps_ViewerFragment
  componentType?: ComponentType
  compactHeader?: boolean
}

export const ChooseFrequencyLaterSteps = ({
  viewer,
  offerLockData,
  componentType = 'modal',
  compactHeader,
}: ChooseFrequencyLaterStepsProps) => {
  return (
    <ChooseFrequencyLaterContextProvider
      offerLockData={offerLockData}
      componentType={componentType}
      compactHeader={compactHeader}
    >
      <ChooseFrequencyLaterStepsContent offerLockData={offerLockData} viewer={viewer} />
    </ChooseFrequencyLaterContextProvider>
  )
}

ChooseFrequencyLaterSteps.fragments = {
  offerLockData: gql`
    fragment ChooseFrequencyLaterSteps_offerLockData on OfferLockData {
      ...ChooseFrequencyLaterStepsContent_offerLockData
    }
    ${ChooseFrequencyLaterStepsContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment ChooseFrequencyLaterSteps_viewer on Profile {
      ...ChooseFrequencyLaterStepsContent_viewer
    }
    ${ChooseFrequencyLaterStepsContent.fragments.viewer}
  `,
}
